import { useQuery } from 'react-query';
import { getAssessment } from 'src/api/assessment';
import { QKeys, Variable } from 'src/api/types';

type UseAssessmentVariables = (a: { assessmentId?: string }) => {
  assessmentVariables: Variable[] | null;
  isAssessmentVariablesLoading: boolean;
  refetch: () => Promise<Variable[] | null>;
};

const useAssessmentVariables: UseAssessmentVariables = ({ assessmentId }) => {
  const {
    data,
    isLoading,
    refetch: queryRefetch,
  } = useQuery([QKeys.Assessment, { assessmentId }], getAssessment, {
    enabled: !!assessmentId,
  });

  const refetch = async () => {
    const result = await queryRefetch();
    return result?.variables || null;
  };

  return { assessmentVariables: data?.variables || null, isAssessmentVariablesLoading: isLoading, refetch };
};

export default useAssessmentVariables;
